import React, {useState} from 'react';
import Logout from '../authentication/Logout';
import { useUser, isManager, isChief, isAdmin } from '../contexts/UserContext';
//import logo from '../assets/images/trustymoWhite.png'; 
import logo from '../assets/images/logo.jpg'

const Menu = ({connected}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const user = useUser(); 

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="bg-primary shadow-lg p-4">
      <div className="container mx-auto">
        <div className="md:flex justify-between items-center">
          <div className="flex justify-between items-center">
            <a href='/'> 
              <img src={logo} alt="logo Digital Silo" className='h-16 object-cover'/>
            </a>

            <div className="md:hidden">
              {/* Bouton de menu pour les écrans mobiles */}
              <button className="text-white" onClick={toggleMenu}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {menuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
          

          <div className={`md:flex md:space-x-4 ${menuOpen ? 'block' : 'hidden'} mt-4 md:mt-0`}>
            {connected ? (
              <>
                <a
                  href="/"
                  className="block text-white hover:text-secondary transition duration-300 mb-2 font-semibold"
                >
                  Tableau de bord
                </a>
                {isAdmin(user.user) ? (
                  <a
                    href="/utilisateurs"
                    className="block text-white hover:text-secondary transition duration-300 mb-2 font-semibold">
                    Utilisateurs
                  </a>
                ) : null }
                {isChief(user.user) || isManager(user.user) ? (
                  <a
                    href="/maintenance"
                    className="block text-white hover:text-secondary transition duration-300 mb-2 font-semibold">
                    Rapports de maintenance
                  </a>
                ) : null }
                {isManager(user.user) ? (
                  <a
                    href="/operateurs"
                    className="block text-white hover:text-secondary transition duration-300 mb-2 font-semibold">
                    Opérateurs / Sous traitants
                  </a>
                ) : null }
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) => console.log(e)}
                  style={{ display: "none" }}
                  id="cameraInput"
                />
                <a
                  href="#"
                  onClick={() => document.getElementById("cameraInput").click()}
                  className="block md:hidden text-white hover:text-secondary transition duration-300 mb-2 font-semibold">
                  Scanner QR-Code
                </a>
                <div className="block md:inline mb-2">
                  <Logout />
                </div>
              </>
            ) : (
              <>
                <a
                  href="/connexion"
                  className="block text-white hover:text-secondary transition duration-300 font-semibold"
                >
                  Connexion
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
  
};

export default Menu;